export const BLUR_EVENT_NAME = "agent:instructions:blur";
export const INSTRUCTIONS_DEBOUNCE_MS = 250;
